import React from 'react';

const WelcomeText = () => (
  <React.Fragment>
    <div>
      <span>
        <span>Type</span>
        <code>
          help
        </code>
        <span>to get a help menu</span>
      </span>
    </div>
  </React.Fragment>
);

export default WelcomeText;
